import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '../../angular-wallet-base/store/appState';
import { SubscriptionListenerComponent } from '../../angular-wallet-base/SubscriptionListenerComponent';
import { getMnemonic } from '../../angular-wallet-base/store/wallet';
import { SetMnemonicAction } from '../../angular-wallet-base/actions/wallet.actions';
import { TranslateService } from '@ngx-translate/core';
import { AlertController, Platform } from '@ionic/angular';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { copyToClipboard } from '../../angular-wallet-base/utils';

@Component({
  selector: 'show-recovery-phrase',
  templateUrl: 'show-recovery-phrase.page.html',
  styleUrls: ['show-recovery-phrase.page.scss']
})
export class ShowRecoveryPhrasePage extends SubscriptionListenerComponent implements OnInit, OnDestroy {

  public mnemonic: string;

  constructor(protected store: Store<AppState>,
              private clipboard: Clipboard,
              private alertController: AlertController,
              private translate: TranslateService,
              private platform: Platform) {
    super(store);
  }

  ngOnInit() {
    this.subscriptions.add(this.store.select(getMnemonic).subscribe(mnemonic => this.mnemonic = mnemonic));
  }

  ngOnDestroy() {
    this.store.dispatch(new SetMnemonicAction({mnemonic: ''}));
  }

  async copyToClipboard() {
    if (this.platform.is('cordova')) {
      await this.clipboard.copy(this.mnemonic);
      await this.presentAlert(this.mnemonic);
    } else {
      copyToClipboard(this.mnemonic);
      await this.presentAlert(this.mnemonic);
    }
  }

  async presentAlert(message) {
    const alert = await this.alertController.create({
      header: await this.translate.get('tokens.receive.alert_copied_to_clipboard').toPromise(),
      message,
    });
    await alert.present();
  }
}
